import React, {useEffect, useState} from "react";
import {state, cameraState, setCamera} from "../../state";
import {Spherical, Vector3} from "three";
import {useSnapshot} from "valtio";
import {useFrame, useThree} from "@react-three/fiber";
import { useSpring, animated } from '@react-spring/three'

const CamaraController = ({orbit}) => {
  
  const {currentCamPos, camaraPositions, getModulesContainerData, defaultPosition, defaultTarget, minDistance} = useSnapshot(cameraState);
  const {dimension} = useSnapshot(state);
  
  let currCamPos;
  let animShotsInAction = false;
  let animModuleInAction = false;
  
  let newPos = new Vector3(0, 0, 0);
  let newTarget = new Vector3(0, 0, 0);
  
  let t = 0;
  let dt = 0.004;
  
  useFrame(() => {
    
    let sph = new Spherical();
    //console.log(sph.setFromVector3(orbit.current.object.position));
    if (animShotsInAction && t < 0.3) {
      
      let ti = t += dt;
      orbit.current["object"].position.lerp(newPos, ti);
      orbit.current.target.lerp(newTarget, ti);
      
    } else {
      animShotsInAction = false;
    }
    
    if (animModuleInAction && t < 0.2) {
    
      let ti = t += dt;
      orbit.current["object"].position.lerp(newPos, ti);
      orbit.current.target.lerp(newTarget, ti);
    
    } else {
      animModuleInAction = false;
    }
    
  });
  
  useEffect(() => {
    
    if (!camaraPositions) return;
    
    currCamPos = camaraPositions[Object.keys(camaraPositions)[currentCamPos]];
    
    newPos = new Vector3(
      currCamPos.pos.x,
      currCamPos.pos.y,
      currCamPos.pos.z
    )
    
    newTarget = new Vector3(
      currCamPos.target.x,
      currCamPos.target.y,
      currCamPos.target.z
    )
    
    animShotsInAction = true;
    
  }, [currentCamPos]);
  
  
/*
    module-unit position update
*/

  
  useEffect(() => {
    
    const data = getModulesContainerData;
    
    const newPosX = data.modulesCurrContainerPosition.x - data.modulesLastContainerPosition.x;
    const newPosZ = data.modulesCurrContainerPosition.z - data.modulesLastContainerPosition.z;
    
    const newCentX = data.modulesContainerCenter.x;
    const newCentZ = data.modulesContainerCenter.z;
    
    if (newPosX) {
      
      //  animated --------------------------------------
      
      animModuleInAction = true;
      
      let posX = orbit.current["object"].position.x;
      let posZ = orbit.current["object"].position.z;
      
      newPos = new Vector3(posX += newPosX, 0, posZ += newPosZ);
      newTarget = new Vector3(newCentX, 0, newCentZ);
      
      // --------------------------------------------------
      // none animated ------------------------------------
      
      // orbit.current["object"].position.x += newPosX;
      // orbit.current["object"].position.z += newPosZ;
      // orbit.current.target.x = newCentX;
      // orbit.current.target.z = newCentZ;
      
      // -------------------------------------------------
      
      orbit.current.update();
 
    }
    
  }, [ getModulesContainerData]);

  useEffect(()=>{
    orbit.current.minDistance = minDistance;
  },[minDistance]);
  
  
  useEffect(() => {
    
    // default cam pos - done here
    // const defaultPos = new Vector3(0, -2, 5);
    // const defaultTarget = new Vector3(0, 0, 0);

    let sphPos = new Spherical().setFromCartesianCoords(-9.17, 3.44, 7.43);
    sphPos.radius = camZs[dimension[0]][dimension[1]].rad;
    
    //orbit.current["object"].position.x = 0;
    //orbit.current["object"].position.y = 1.8506178062217045;
    //orbit.current["object"].position.z = camZs[dimension[0]][dimension[1]];

    orbit.current["object"].position.setFromSpherical(sphPos);
    
    orbit.current.target = new Vector3(0, 0, 0);

    orbit.current.maxPolarAngle = 1.5;
    orbit.current.minDistance = camZs[dimension[0]][dimension[1]].minD;
    orbit.current.maxDistance = 20;
    
    animShotsInAction = false;
    animModuleInAction= false;
    
    orbit.current["object"].updateProjectionMatrix();

    setCamera(orbit);
    
    const func = ()=>
      {
        console.log(orbit.current.object.position);
        requestAnimationFrame(func);
      };
    func();
  }, []);
  
  let camZs = {
    24: {
      26: {minD: 3.5, maxD: 10, rad: 7.18},
      32: {minD: 3.5, maxD: 10, rad: 7.36},
      38: {minD: 4.0, maxD: 10, rad: 7.53},
      44: {minD: 4.0, maxD: 10, rad: 7.73},
      50: {minD: 4.0, maxD: 10, rad: 7.92},
      56: {minD: 4.5, maxD: 10, rad: 8.13},
      62: {minD: 4.5, maxD: 10, rad: 8.34},
      68: {minD: 5.0, maxD: 10, rad: 8.56},
      74: {minD: 5.0, maxD: 10, rad: 8.78},
      80: {minD: 5.0, maxD: 10, rad: 9.01},
      86: {minD: 5.5, maxD: 10, rad: 9.24},
      92: {minD: 5.5, maxD: 10, rad: 9.49},
      98: {minD: 6.0, maxD: 10, rad: 9.73},
      104: {minD: 6.0, maxD: 10, rad: 9.99},
      110: {minD: 6.5, maxD: 10, rad: 10.24},
      116: {minD: 7.0, maxD: 10, rad: 10.51},
      122: {minD: 7.0, maxD: 10, rad: 10.78},
      128: {minD: 7.0, maxD: 10, rad: 11.07},
      134: {minD: 7.5, maxD: 10, rad: 11.35},
      140: {minD: 8.0, maxD: 10, rad: 11.65},
      146: {minD: 8.0, maxD: 10, rad: 11.95},
      152: {minD: 8.5, maxD: 10, rad: 12.25}
    },
    30: {
      26: {minD: 3.5, maxD: 10, rad: 7.18},
      32: {minD: 3.5, maxD: 10, rad: 7.36},
      38: {minD: 4.0, maxD: 10, rad: 7.53},
      44: {minD: 4.0, maxD: 10, rad: 7.73},
      50: {minD: 4.0, maxD: 10, rad: 7.92},
      56: {minD: 4.5, maxD: 10, rad: 8.13},
      62: {minD: 4.5, maxD: 10, rad: 8.34},
      68: {minD: 5.0, maxD: 10, rad: 8.56},
      74: {minD: 5.0, maxD: 10, rad: 8.78},
      80: {minD: 5.0, maxD: 10, rad: 9.01},
      86: {minD: 5.5, maxD: 10, rad: 9.24},
      92: {minD: 5.5, maxD: 10, rad: 9.49},
      98: {minD: 6.0, maxD: 10, rad: 9.73},
      104: {minD: 6.0, maxD: 10, rad: 9.99},
      110: {minD: 6.5, maxD: 10, rad: 10.24},
      116: {minD: 7.0, maxD: 10, rad: 10.51},
      122: {minD: 7.0, maxD: 10, rad: 10.78},
      128: {minD: 7.0, maxD: 10, rad: 11.07},
      134: {minD: 7.5, maxD: 10, rad: 11.35},
      140: {minD: 8.0, maxD: 10, rad: 11.65},
      146: {minD: 8.0, maxD: 10, rad: 11.95},
      152: {minD: 8.5, maxD: 10, rad: 12.25}
    },
    36: {
      26: {minD: 3.5, maxD: 10, rad: 7.18},
      32: {minD: 4.0, maxD: 10, rad: 7.36},
      38: {minD: 4.0, maxD: 10, rad: 7.53},
      44: {minD: 4.5, maxD: 10, rad: 7.73},
      50: {minD: 4.5, maxD: 10, rad: 7.92},
      56: {minD: 5.0, maxD: 10, rad: 8.13},
      62: {minD: 5.0, maxD: 10, rad: 8.34},
      68: {minD: 5.5, maxD: 10, rad: 8.56},
      74: {minD: 5.5, maxD: 10, rad: 8.78},
      80: {minD: 5.5, maxD: 10, rad: 9.01},
      86: {minD: 6.0, maxD: 10, rad: 9.24},
      92: {minD: 6.0, maxD: 10, rad: 9.49},
      98: {minD: 6.5, maxD: 10, rad: 9.73},
      104: {minD: 6.5, maxD: 10, rad: 9.99},
      110: {minD: 7.0, maxD: 10, rad: 10.24},
      116: {minD: 7.5, maxD: 10, rad: 10.51},
      122: {minD: 7.5, maxD: 10, rad: 10.78},
      128: {minD: 7.5, maxD: 10, rad: 11.07},
      134: {minD: 8.0, maxD: 10, rad: 11.35},
      140: {minD: 8.5, maxD: 10, rad: 11.65},
      146: {minD: 8.5, maxD: 10, rad: 11.95},
      152: {minD: 9.0, maxD: 10, rad: 12.25}
    },
    42: {
      26: {minD: 4.0, maxD: 10, rad: 7.18},
      32: {minD: 4.0, maxD: 10, rad: 7.36},
      38: {minD: 4.5, maxD: 10, rad: 7.53},
      44: {minD: 4.5, maxD: 10, rad: 7.73},
      50: {minD: 4.5, maxD: 10, rad: 7.92},
      56: {minD: 5.0, maxD: 10, rad: 8.13},
      62: {minD: 5.0, maxD: 10, rad: 8.34},
      68: {minD: 5.5, maxD: 10, rad: 8.56},
      74: {minD: 5.5, maxD: 10, rad: 8.78},
      80: {minD: 5.5, maxD: 10, rad: 9.01},
      86: {minD: 6.0, maxD: 10, rad: 9.24},
      92: {minD: 6.0, maxD: 10, rad: 9.49},
      98: {minD: 6.5, maxD: 10, rad: 9.73},
      104: {minD: 6.5, maxD: 10, rad: 9.99},
      110: {minD: 7.0, maxD: 10, rad: 10.24},
      116: {minD: 7.5, maxD: 10, rad: 10.51},
      122: {minD: 7.5, maxD: 10, rad: 10.78},
      128: {minD: 7.5, maxD: 10, rad: 11.07},
      134: {minD: 8.0, maxD: 10, rad: 11.35},
      140: {minD: 8.5, maxD: 10, rad: 11.65},
      146: {minD: 8.5, maxD: 10, rad: 11.95},
      152: {minD: 9.0, maxD: 10, rad: 12.25}
    },
    48: {
      26: {minD: 4.0, maxD: 10, rad: 7.28},
      32: {minD: 4.0, maxD: 10, rad: 7.46},
      38: {minD: 4.5, maxD: 10, rad: 7.63},
      44: {minD: 4.5, maxD: 10, rad: 7.83},
      50: {minD: 4.5, maxD: 10, rad: 8.02},
      56: {minD: 5.0, maxD: 10, rad: 8.23},
      62: {minD: 5.0, maxD: 10, rad: 8.44},
      68: {minD: 5.5, maxD: 10, rad: 8.66},
      74: {minD: 5.5, maxD: 10, rad: 8.98},
      80: {minD: 5.5, maxD: 10, rad: 9.21},
      86: {minD: 6.0, maxD: 10, rad: 9.44},
      92: {minD: 6.0, maxD: 10, rad: 9.69},
      98: {minD: 6.5, maxD: 10, rad: 9.93},
      104: {minD: 6.5, maxD: 10, rad: 10.24},
      110: {minD: 7.0, maxD: 10, rad: 10.49},
      116: {minD: 7.5, maxD: 10, rad: 10.81},
      122: {minD: 7.5, maxD: 10, rad: 11.08},
      128: {minD: 7.5, maxD: 10, rad: 11.42},
      134: {minD: 8.0, maxD: 10, rad: 11.70},
      140: {minD: 8.5, maxD: 10, rad: 12.05},
      146: {minD: 8.5, maxD: 10, rad: 12.45},
      152: {minD: 9.0, maxD: 10, rad: 12.75}
    }
  }
}

export default CamaraController;

